module.exports = __webpack_public_path__ + "media/pages/assets/images/calendar/2017/july-e8c971be752bac6a096fe3efeafd5b7a.png";